// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import PushController from "./push_controller"
application.register("push", PushController)

import VerifyController from "./verify_controller"
application.register("verify", VerifyController)
